import React, { useContext } from 'react';

interface SpecialJobContext {
  openEmployee: number | null | undefined;
  setOpenEmployee: (specialJobId: number | null | undefined) => void;
}

const specialJobContext = React.createContext<SpecialJobContext>({
  openEmployee: undefined,
  setOpenEmployee: () => {},
});

export const SpecialJobContextProvider = specialJobContext.Provider;
export const SpecialJobContextConsumer = specialJobContext.Consumer;

export const useSpecialJobContext = () => {
  return useContext(specialJobContext);
};
